import {
  uploadStatusFormatter,
  reUploadLinkFormatter,
  shortDatePlusTimeFormatter,
  shortDateFormatter,
  localShortDatePlusTimeFormatter,
  MarkFailedFormatter,
  DownloadLinkFormatter
} from "../../gridFormatters";

export const allUploadDefs = [
  {
    field: "_id",
    headerName: "Upload ID",
    hide: true,
  },
  {
    field: "parsingStatus",
    headerName: "Status",

    cellRenderer: uploadStatusFormatter,
    filter: "agSetColumnFilter",
    filterParams: {
      cellRenderer: uploadStatusFormatter,
    },
    // aggFunc: "max"
  },
  {
    field: "clientName",
    headerName: "Client",

  },
  {
    field: "originalFileName",
    headerName: "Original File",

  },
  {
    field: "stampedFileName",
    headerName: "Stamped File",

    cellRenderer: DownloadLinkFormatter,
  },
  {
    field: "uploadedBy",
    headerName: "Uploaded By",

  },
  // {
  // 	field: "clientName",
  // 	headerName: "Client",
  // 	resizable: true,
  // 	valueGetter: function(params) {
  // 		return params.data.clientName?.[0]?.name;
  // 	}
  // },
  {
    field: "deviceTypeCode",
    headerName: "Device Type",

  },
  {
    field: "uploadDate",
    headerName: "Upload Date",

    cellRenderer: shortDatePlusTimeFormatter,
    // aggFunc: "max"
  },
  {
    field: "expireAt",
    headerName: "Expires",

    cellRenderer: localShortDatePlusTimeFormatter,
    // aggFunc: "max"
  },

  {
    field: "fileSize",
    headerName: "File Size (MB)",

  },

  {
    field: "RU",
    headerName: " ",

    enableRowGroup: false,
    cellRenderer: reUploadLinkFormatter,
  },
  {
    field: "MarkFailed",
    headerName: "Mark",

    enableRowGroup: false,
    cellRenderer: MarkFailedFormatter,
  },
  {
    field: "parseAttempts",
    headerName: "Parse Failures",
    aggFunc: "sum",
  },
  {
    field: "runtime",
    headerName: "Run Time in Seconds",
  },
  // ,
  // {
  // 	field: "processStatDateTime",
  // 	headerName: "Run Time in Seconds",
  // },
  //
  // 	{
  // 	field: "processEndDateTime",
  // 	headerName: "Run Time in Seconds",
  // },
];

export const uploadsDefs = [
  {
    field: "_id",
    headerName: "Upload ID",
    hide: true,
  },
  {
    field: "parsingStatus",
    headerName: "Status",

    cellRenderer: uploadStatusFormatter,
    filter: "agSetColumnFilter",
    filterParams: {
      cellRenderer: uploadStatusFormatter,
    },
    // aggFunc: "max"
  },
  {
    field: "originalFileName",
    headerName: "Original File",

  },
  {
    field: "stampedFileName",
    headerName: "Stamped File",

    cellRenderer: DownloadLinkFormatter,
  },
  {
    field: "uploadedBy",
    headerName: "Uploaded By",

  },
  {
    field: "deviceName",
    headerName: "Device Name",

    hide: true,
  },
  {
    field: "deviceTypeCode",
    headerName: "Device Type",

  },
  {
    field: "collectionDate",
    headerName: "Collection Date",

    cellRenderer: shortDateFormatter,
    hide: true,
  },
  {
    field: "uploadDate",
    headerName: "Upload Date",

    cellRenderer: localShortDatePlusTimeFormatter,
  },
  {
    field: "expireAt",
    headerName: "Expires",

    cellRenderer: shortDatePlusTimeFormatter,
  },
  {
    field: "fileSize",
    headerName: "File Size (MB)",

  },
  {
    field: "RU",
    headerName: " ",
    enableRowGroup: false,
    cellRenderer: reUploadLinkFormatter,
  },
  {
    field: "MarkFailed",
    headerName: "Mark",
    enableRowGroup: false,
    cellRenderer: MarkFailedFormatter,
  },
  {
    field: "parseAttempts",
    headerName: "Parse Failures",
  },
  {
    field: "runtime",
    headerName: "Run Time in Seconds",
  },
  // ,
  // {
  // 	field: "processStatDateTime",
  // 	headerName: "Run Time in Seconds",
  // },
  // {
  // 	field: "processEndDateTime",
  // 	headerName: "Run Time in Seconds",
  // },
];

export const localUploadsDefs = [
  {
    field: "_id",
    headerName: "Upload ID",
    hide: true,
  },
  {
    field: "parsingStatus",
    headerName: "Status",

    cellRenderer: uploadStatusFormatter,
    filter: "agSetColumnFilter",
    filterParams: {
      cellRenderer: uploadStatusFormatter,
    },
    // aggFunc: "max"
  },
  {
    field: "originalFileName",
    headerName: "Original File",

  },
  {
    field: "stampedFileName",
    headerName: "Stamped File",

    cellRenderer: DownloadLinkFormatter,
  },
  {
    field: "uploadedBy",
    headerName: "Uploaded By",

  },
  {
    field: "deviceName",
    headerName: "Device Name",

    hide: true,
  },
  {
    field: "deviceTypeCode",
    headerName: "Device Type",

  },
  {
    field: "collectionDate",
    headerName: "Collection Date",

    cellRenderer: shortDateFormatter,
    hide: true,
  },
  {
    field: "uploadDate",
    headerName: "Upload Date",

    cellRenderer: shortDatePlusTimeFormatter,
  },
  {
    field: "expireAt",
    headerName: "Expires",

    cellRenderer: shortDatePlusTimeFormatter,
  },
  {
    field: "fileSize",
    headerName: "File Size (MB)",

  },
  {
    field: "MarkFailed",
    headerName: "Mark",

    enableRowGroup: false,
    cellRenderer: MarkFailedFormatter,
  },
  {
    field: "parseAttempts",
    headerName: "Parse Failures",
  },
  {
    field: "runtime",
    headerName: "Run Time in Seconds",
  },
  // ,
  // {
  // 	field: "processStatDateTime",
  // 	headerName: "Run Time in Seconds",
  // },
  // {
  // 	field: "processEndDateTime",
  // 	headerName: "Run Time in Seconds",
  // },
];
